import React, { FC } from "react";

import { PieChart, ModalWrapper } from "~/ui";

type PropsType = {
  onClose: () => void;
  title: string;
  className?: string;
  dataSets: {
    label: string;
    value: number;
  }[];
};

export const PieChartModal: FC<PropsType> = ({
  onClose,
  title,
  dataSets,
  className = "",
}: PropsType) => {
  return (
    <ModalWrapper onClose={onClose} headerTitle={title} className={className}>
      <div className="mt-4 rounded-md">
        <PieChart dataSets={dataSets} />
      </div>
    </ModalWrapper>
  );
};
